import React from 'react';

import ModalContainer from '@components/modals/ModalContainer';

import ChipList from '@features/filter/ChipList';

const ChipModal = ({ chipList = [], removeItemFromFilter, onClose, onClearAll }) => {
	return (
		<ModalContainer centered className="chips-modal">
			<div className="common-popup">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0 invisible">.</h3>
					</div>
					<div className="close-btn" onClick={onClose}>
						<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
					</div>
				</div>
				<div className="common-popup-body scroll-y-label">
					<div className="chip-container gray-chips d-flex flex-wrap gap-2">
						<ChipList chipList={chipList} removeItemFromFilter={removeItemFromFilter} />
						{chipList?.length > 0 && (
							<span className="clear" onClick={onClearAll}>
								Clear all
							</span>
						)}
					</div>
				</div>
			</div>
		</ModalContainer>
	);
};

export default ChipModal;
